// biome-ignore lint/correctness/noUndeclaredVariables: Global webpack variable
__webpack_nonce__ = window.cspNonce
